import { AnalyticsEvent } from '~/modules/services/analyticsService';
import { ALLOWED_LINKS_AS_TABS, AnalyticsEventTopic, MORE_RESOURCES_EVENT_CONTEXT } from '../analyticsHelper';
import { GA4ListingDetailClickEvent, GtmEventType } from './gtmEventType';
import { getAppCost, getAppType, getQueryStringValue } from './gtmEventTypeHelper';

export type ListingDetailsClickAnalyticsEvent = {
    clickUrl: string;
    pricing: string;
    listingRecordType: string;
    sponsoredCampaign: string;
    oafId: string;
    title: string;
    button?: any;
    link?: any;
    publisher: string;
    context: string;
    lead_type?: string;
    caption?: string;
} & AnalyticsEvent;

export class GtmListingDetailClickType extends GtmEventType {
    static ctaClickElements = ['test drive', 'get it now', 'watch demo', 'add to favorites', 'try it free'];
    validClickElements = [...GtmListingDetailClickType.ctaClickElements, 'pricing details'];

    // @ts-expect-error * Automated Type Error Fix
    canHandle(event): boolean {
        return event.topic === AnalyticsEventTopic.ANALYTICS_CLICK && event.oafId && this.isValidElementClick(event);
    }

    // @ts-expect-error * Automated Type Error Fix
    isValidElementClick(event) {
        const buttonName = event.button?.callToAction?.name || event.link?.callToAction?.name;
        return (
            this.validClickElements.includes(buttonName) ||
            event.elementType === 'tab' ||
            (event.elementType === 'link' && ALLOWED_LINKS_AS_TABS.includes(event.link?.callToAction?.name)) ||
            (event.elementType === 'link' && MORE_RESOURCES_EVENT_CONTEXT === event.context)
        );
    }

    getBody(event: ListingDetailsClickAnalyticsEvent): GA4ListingDetailClickEvent {
        const {
            clickUrl,
            pricing,
            listingRecordType,
            sponsoredCampaign,
            recommended,
            oafId,
            title,
            url,
            button,
            link,
        } = event;
        const elementClickUrl = clickUrl || link?.callToAction?.url || url;
        const body = {
            event: 'custEv_appEngagement',
            click_text:
                button?.callToAction?.name ||
                button?.callToAction?.label ||
                link?.callToAction?.name ||
                link?.callToAction?.label ||
                event.caption,
            click_url: elementClickUrl,
            element_title: GtmListingDetailClickType.getItemTitle(event),
            element_type: GtmListingDetailClickType.getElementType(event),
            internal_driver: getQueryStringValue(elementClickUrl, 'd'),
            lp_detail_interaction: true,
            app_cost: getAppCost(pricing),
            app_type: getAppType(listingRecordType),
            featured: !!sponsoredCampaign,
            recommended: recommended,
            ignore_hover: false,
            internal_article: false,
            internal_source: getQueryStringValue(elementClickUrl, 'channel'),
            listing_id: oafId,
            listing_name: title,
            listing_type: listingRecordType,
            listing_url: url,
            hover_intent: false,
            page_type: 'listing details',
        };

        return body;
    }

    // @ts-expect-error * Automated Type Error Fix
    public static getLeadEventType(event): string {
        const eventLeadText = event.button?.callToAction?.name || event.link?.callToAction?.name;
        if (eventLeadText === 'test drive' || eventLeadText === 'watch demo') {
            return eventLeadText;
        }
        // @ts-expect-error * Automated Type Error Fix
        return undefined;
    }

    // @ts-expect-error * Automated Type Error Fix
    public static getItemTitle(event) {
        return event.lead_type === 'demo' ? 'watch demo' : event.customTitle || event.title;
    }

    // @ts-expect-error * Automated Type Error Fix
    public static isCtaClick(event): boolean {
        const buttonName = event.button?.callToAction?.name || event.link?.callToAction?.name;
        return GtmListingDetailClickType.ctaClickElements.includes(buttonName);
    }

    // @ts-expect-error * Automated Type Error Fix
    public static getElementType(event): string {
        const buttonName = event.button?.callToAction?.name || event.link?.callToAction?.name;
        return GtmListingDetailClickType.ctaClickElements.includes(buttonName) ? 'button' : event.elementType;
    }
}
